/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_Constants_DeliveryStatus } from '../models/Routemize_Constants_DeliveryStatus';
import type { Routemize_Constants_NotificationPriority } from '../models/Routemize_Constants_NotificationPriority';
import type { Routemize_Constants_NotificationType } from '../models/Routemize_Constants_NotificationType';
import type { Routemize_Core_Dtos_PagedResultDto_1 } from '../models/Routemize_Core_Dtos_PagedResultDto_1';
import type { Routemize_DTOs_BulkDeleteNotificationDTO } from '../models/Routemize_DTOs_BulkDeleteNotificationDTO';
import type { Routemize_DTOs_ChannelPerformanceDTO } from '../models/Routemize_DTOs_ChannelPerformanceDTO';
import type { Routemize_DTOs_CreateNotificationDTO } from '../models/Routemize_DTOs_CreateNotificationDTO';
import type { Routemize_DTOs_MarkAsReadDTO } from '../models/Routemize_DTOs_MarkAsReadDTO';
import type { Routemize_DTOs_MarkAsUnreadDTO } from '../models/Routemize_DTOs_MarkAsUnreadDTO';
import type { Routemize_DTOs_NotificationAnalyticsDTO } from '../models/Routemize_DTOs_NotificationAnalyticsDTO';
import type { Routemize_DTOs_NotificationDeliveryReportDTO } from '../models/Routemize_DTOs_NotificationDeliveryReportDTO';
import type { Routemize_DTOs_NotificationDTO } from '../models/Routemize_DTOs_NotificationDTO';
import type { Routemize_DTOs_NotificationDTO_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_ } from '../models/Routemize_DTOs_NotificationDTO_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_';
import type { Routemize_DTOs_NotificationSummaryDTO_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_ } from '../models/Routemize_DTOs_NotificationSummaryDTO_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_';
import type { Routemize_DTOs_NotificationTypeDTO } from '../models/Routemize_DTOs_NotificationTypeDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NotificationService {
    /**
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns Routemize_Core_Dtos_PagedResultDto_1<Routemize_DTOs_NotificationDTO_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_> OK
     * @throws ApiError
     */
    public static getApiAppNotificationGetList(
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<Routemize_Core_Dtos_PagedResultDto_1> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/notification/getList',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
        });
    }
    /**
     * @param id
     * @returns Routemize_DTOs_NotificationDTO OK
     * @throws ApiError
     */
    public static getApiAppNotificationGetById(
        id: string,
    ): CancelablePromise<Routemize_DTOs_NotificationDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/notification/{id}/getByID',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppNotificationDelete(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/notification/{id}/delete',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_NotificationDTO OK
     * @throws ApiError
     */
    public static putApiAppNotificationUpdate(
        requestBody?: Routemize_DTOs_CreateNotificationDTO,
    ): CancelablePromise<Routemize_DTOs_NotificationDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/notification/update',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param isRead
     * @param notificationType  Possible values: Appointment = 1, Request = 2, System = 3, Reminder = 4, Alert = 5, Contact = 6, AppointmentCreated = 7, AppointmentUpdated = 8, AppointmentCancelled = 9, DailyIncompleteRequests = 10, EmailChanged = 11, ContactCaptured = 12, VoiceMessage = 13
     * @param priority  Possible values: Low = 1, Normal = 2, High = 3, Critical = 4
     * @param deliveryStatus  Possible values: Pending = 1, Sent = 2, Failed = 3, Partial = 4, Delivered = 5, Opened = 6
     * @param fromDate
     * @param toDate
     * @param searchTerm
     * @param userId
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns Routemize_Core_Dtos_PagedResultDto_1<Routemize_DTOs_NotificationSummaryDTO_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_> OK
     * @throws ApiError
     */
    public static getApiAppNotificationGetUserNotifications(
        isRead?: boolean,
        notificationType?: Routemize_Constants_NotificationType,
        priority?: Routemize_Constants_NotificationPriority,
        deliveryStatus?: Routemize_Constants_DeliveryStatus,
        fromDate?: string,
        toDate?: string,
        searchTerm?: string,
        userId?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<Routemize_Core_Dtos_PagedResultDto_1> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/notification/getUserNotifications',
            query: {
                'IsRead': isRead,
                'NotificationType': notificationType,
                'Priority': priority,
                'DeliveryStatus': deliveryStatus,
                'FromDate': fromDate,
                'ToDate': toDate,
                'SearchTerm': searchTerm,
                'UserId': userId,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppNotificationMarkAsRead(
        requestBody?: Routemize_DTOs_MarkAsReadDTO,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/notification/markAsRead',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppNotificationMarkAsUnread(
        requestBody?: Routemize_DTOs_MarkAsUnreadDTO,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/notification/markAsUnread',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppNotificationBulkDelete(
        requestBody?: Routemize_DTOs_BulkDeleteNotificationDTO,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/notification/bulkDelete',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns number OK
     * @throws ApiError
     */
    public static getApiAppNotificationGetUnreadCount(): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/notification/getUnreadCount',
        });
    }
    /**
     * @returns Routemize_DTOs_NotificationAnalyticsDTO OK
     * @throws ApiError
     */
    public static getApiAppNotificationGetAnalytics(): CancelablePromise<Routemize_DTOs_NotificationAnalyticsDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/notification/getAnalytics',
        });
    }
    /**
     * @param notificationId
     * @returns Routemize_DTOs_NotificationDeliveryReportDTO OK
     * @throws ApiError
     */
    public static getApiAppNotificationGetDeliveryReport(
        notificationId: string,
    ): CancelablePromise<Routemize_DTOs_NotificationDeliveryReportDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/notification/getDeliveryReport/{notificationId}',
            path: {
                'notificationId': notificationId,
            },
        });
    }
    /**
     * @returns Routemize_DTOs_ChannelPerformanceDTO OK
     * @throws ApiError
     */
    public static getApiAppNotificationGetChannelPerformance(): CancelablePromise<Array<Routemize_DTOs_ChannelPerformanceDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/notification/getChannelPerformance',
        });
    }
    /**
     * @returns Routemize_DTOs_NotificationTypeDTO OK
     * @throws ApiError
     */
    public static getApiAppNotificationGetNotificationTypes(): CancelablePromise<Array<Routemize_DTOs_NotificationTypeDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/notification/getNotificationTypes',
        });
    }
}
